import { type ChangeTeamStatusValue } from '@/api/changeTeamStatusValue.ts'

import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface CustomerNotFoundApiVariables {
  regionId: string
  transportRequestId: string
  teamStatus: ChangeTeamStatusValue
}

export const useCustomerNotFound = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, CustomerNotFoundApiVariables>
) => useUpdateTransportRequestOnrApi<void, CustomerNotFoundApiVariables>({ type: 'piloteCustomerNotFound', ...options })
